import { DisabledPrompt, useRoute } from "@bcm-dev/bcms-vite";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import ControlToggleView from "components/shared/views/BaseToggleView/components/ControlToggleView";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import React, { useState } from "react";
import { SVGAsset } from "res";
import "./styles.css";

/**
 * @function MerchantControlsPage
 * @return {React.Component}
 * @exported true
 * @description The main component for MerchantControlsPage
 */
export default function MerchantControlsPage(props) {
  const navigate = useRoute();

  const [ state, setState ] = useState(true);
  const toggle = value => setState(value);

  const cancel = evt => navigate(-1);
  const disabledChevron = <DisabledPrompt><SVGAsset id="RightChevronIcon" /></DisabledPrompt>;

  return (
    <MainContentContainer className="merchant-controls-page" header={
      <MainContentHeader text="Merchant Controls"
      dataPoint="Merchant_Controls_Header"/>
    }>
      <FormContainer>
        <MerchantControlRow 
          mainText="Enable Merchant Controls" 
          subText="Allow selected merchant types." 
          onChange={ toggle }
          checked={ state } 
          dataPoint="Merchant_Controls_Department_Store"
          className="hide-chevron-icon"/>
        
        <FormRow>
          <MerchantControlRow
            mainText="Department Store"
            subText="Clothing, office supplies, florists, auto dealers, home goods a…"
            expandedText="Clothing, office supplies, florists, auto dealers, home goods, and sports supplies. Purchases at department store merchants are denied if this merchant Type is off."
            checked={ state } 
            dataPoint="Merchant_Controls_Department_Store"
            className={ !state ? "disabled" : "" } />
        </FormRow>

        <FormRow>
          <MerchantControlRow
            mainText="Entertainment"
            subText="Theme parks, theatres, books, music, games, and sporting e..."
            checked={ state }
            icon={ disabledChevron } 
            dataPoint="Merchant_Controls_Entertainment"
            className={ !state ? "disabled" : "" } />
        </FormRow>

        <FormRow>
          <MerchantControlRow
            mainText="Gas Station"
            subText="Filling stations, petroleum, and petroleum products. Purcha..."
            checked={ state }
            dataPoint="Merchant_Controls_Gas_Station"
            icon={ disabledChevron }
            className={ !state ? "disabled" : "" } 
          />
        </FormRow>

        <FormRow>
          <MerchantControlRow
            mainText="Grocery"
            subText="Supermarkets, bakeries, butchers, specialty markets, and c..."
            checked={ state }
            dataPoint="Merchant_Controls_Department_Store"
            icon={ disabledChevron }
            className={ !state ? "disabled" : "" } 
          />
        </FormRow>

        <FormRow>
          <MerchantControlRow
            mainText="Household"
            subText="Utilities, contracted services, business services, courier servic..."
            checked={ state }
            dataPoint="Merchant_Controls_Household"
            icon={ disabledChevron }
            className={ !state ? "disabled" : "" } 
          />
        </FormRow>

        <FormRow>
          <MerchantControlRow
            mainText="Personal Care"
            subText="Drug stores, pharmacies, health services, medical services, a..."
            checked={ state }
            dataPoint="Merchant_Controls_Department_Store"
            icon={ disabledChevron }
            className={ !state ? "disabled" : "" } 
          />
        </FormRow>

        <FormRow>
          <MerchantControlRow
            mainText="Restaurant"
            subText="Cafes, coffee, fast food, catering, and food trucks. Purchases..."
            checked={ state }
            dataPoint="Merchant_Controls_Restaurant"
            icon={ disabledChevron }
            className={ !state ? "disabled" : "" } 
          />
        </FormRow>

        <FormRow>
          <MerchantControlRow
            mainText="Travel"
            subText="Airlines, vehicle rentals, hotels, motels"
            checked={ state }
            dataPoint="Merchant_Controls_Travel"
            icon={ disabledChevron }
            className={ !state ? "disabled" : "" } 
          />
        </FormRow>

        <FormRow>
          <MerchantControlRow
            mainText="Age Restricted"
            subText="Liquor, nicotine, casinos, bars, dating and escort services, an..."
            checked={ state }
            dataPoint="Merchant_Controls_Age_Restricted"
            icon={ disabledChevron }
            className={ !state ? "disabled" : "" } 
          />
        </FormRow>

        <FormRow>
          <MerchantControlRow
            mainText="Other"
            subText="Other cases where merchant types cannot be identified are..."
            checked={ state }
            dataPoint="Merchant_Controls_Other"
            icon={ disabledChevron }
            className={ !state ? "disabled" : "" } 
          />
        </FormRow>

        <FormButtonContainer>
          <DisabledPrompt>
            <UIPrimaryButton text="Apply" dataPoint={"Apply_Button"}/>
          </DisabledPrompt>
          <UICancelButton text="Cancel" dataPoint={"Cancel_Button"} onClick={ cancel } />
        </FormButtonContainer>
      </FormContainer>
    </MainContentContainer>
  );
}

function MerchantControlRow(props) {
  const nonExpanded = props.subText ?? "";
  const expanded = props.expandedText;

  const [ state, setState ] = useState(false);
  const toggle = evt => setState(!state);

  const icon = expanded === undefined
    ? <DisabledPrompt><SVGAsset id="RightChevronIcon" className="clickable chevron-icon" /></DisabledPrompt>
    : <SVGAsset id={ state ? "DownChevronIcon" : "RightChevronIcon" } onClick={ toggle } className="clickable chevron-icon" />

  const textToShow = state ? expanded : nonExpanded;

  return (
    <ControlToggleView
      { ...props }
      subText={ textToShow }
      icon={ icon } />
  );
}